<app-dialog
  [loading]="loggingOut()"
  (cancelAction)="cancelButtonClicked()"
  (confirm)="logOutButtonClicked()"
  cancelButtonText="Cancel"
  confirmButtonText="Log Out"
  [title]="title" />
